"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DropdownItemNestedDropdown = exports.DropdownItem = exports.DropdownDivider = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TextButton = _interopRequireDefault(require("../../../control-components/ui-components/TextButton"));

var _typeGuards = require("../../../libs/typeGuards");

var _GlobalClick = _interopRequireDefault(require("@insided/shared/uikit/GlobalClick"));

var _excluded = ["children", "type", "onClick", "href"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DropdownItem = function DropdownItem(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'normal' : _ref$type,
      _ref$onClick = _ref.onClick,
      _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      href = _ref.href,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  return (0, _preact.h)("li", (0, _extends2.default)({
    className: (0, _classnames.default)('c-dropdown__item', "c-dropdown__item-type-".concat(type)),
    role: "menuitem",
    tabIndex: 0,
    onClick: function onClick(e) {
      return _onClick(e);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();

        _onClick(e);
      }
    }
  }, otherProps), href ? (0, _preact.h)("a", {
    className: (0, _classnames.default)('link', 'qa-topic-post-permalink', 'post__action-dropdown-link'),
    href: (0, _absoluteUrlRuntime.resolveUrl)(href)
  }, children) : children);
};

exports.DropdownItem = DropdownItem;

var DropdownItemNestedDropdown = function DropdownItemNestedDropdown(props) {
  return (0, _preact.h)("li", {
    key: props.key,
    className: "c-dropdown--nested"
  }, props.children);
};

exports.DropdownItemNestedDropdown = DropdownItemNestedDropdown;

var DropdownDivider = function DropdownDivider() {
  return (0, _preact.h)("li", {
    "aria-hidden": true,
    className: "c-dropdown--divider"
  });
};

exports.DropdownDivider = DropdownDivider;

var DropdownComponent = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DropdownComponent, _Component);

  var _super = _createSuper(DropdownComponent);

  function DropdownComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, DropdownComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dropdownContent", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dropdownWrapper", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "TOP", 'top');
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "BOTTOM", 'bottom');
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "RIGHT", 'right');
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "LEFT", 'left');
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isOpen: false,
      isTriggerClicked: false,
      overflow: false
    });
    return _this;
  }

  (0, _createClass2.default)(DropdownComponent, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps, previousState) {
      var _this$dropdownContent, _this$dropdownContent2, _this$dropdownWrapper;

      var contentDimensions = (_this$dropdownContent = this.dropdownContent) === null || _this$dropdownContent === void 0 ? void 0 : (_this$dropdownContent2 = _this$dropdownContent.base) === null || _this$dropdownContent2 === void 0 ? void 0 : _this$dropdownContent2.getBoundingClientRect();
      var wrapperDimensions = (_this$dropdownWrapper = this.dropdownWrapper) === null || _this$dropdownWrapper === void 0 ? void 0 : _this$dropdownWrapper.getBoundingClientRect();

      if (!previousState.isOpen && this.state.isOpen && wrapperDimensions && contentDimensions) {
        if (this.props.position === this.RIGHT || this.props.position === this.TOP || this.props.position === this.BOTTOM) {
          this.setState({
            overflow: wrapperDimensions.right + parseInt(contentDimensions.width) > window.document.body.offsetWidth
          });
        } else if (this.props.position === this.LEFT) {
          this.setState({
            overflow: wrapperDimensions.left < contentDimensions.width
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          trigger = _this$props.trigger,
          children = _this$props.children,
          triggerElement = _this$props.triggerElement,
          disabled = _this$props.disabled,
          popupName = _this$props.popupName,
          customHeight = _this$props.customHeight,
          closeOnDropdownClick = _this$props.closeOnDropdownClick,
          _this$props$openAlway = _this$props.openAlwaysOnTriggerClick,
          openAlwaysOnTriggerClick = _this$props$openAlway === void 0 ? false : _this$props$openAlway,
          isControl = _this$props.isControl,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? 'S' : _this$props$size,
          _this$props$position = _this$props.position,
          position = _this$props$position === void 0 ? this.BOTTOM : _this$props$position,
          _this$props$align = _this$props.align,
          align = _this$props$align === void 0 ? this.LEFT : _this$props$align,
          textButtonStyle = _this$props.textButtonStyle,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className;
      var triggerContent = typeof trigger === 'function' ? trigger(this.state.isOpen) : trigger;
      var Trigger = triggerElement !== null && triggerElement !== void 0 ? triggerElement : _TextButton.default; // eslint-disable-next-line import/no-deprecated

      var renderPropChildren = (0, _typeGuards.getFirstChild)(children);
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('c-dropdown', {
          'c-dropdown c-dropdown--app-control': isControl,
          'c-dropdown c-dropdown--app-destination': !isControl
        }),
        ref: function ref(dropdownWrapper) {
          _this2.dropdownWrapper = dropdownWrapper;
        }
      }, (0, _preact.h)(Trigger, {
        style: textButtonStyle !== null && textButtonStyle !== void 0 ? textButtonStyle : {},
        "aria-haspopup": !!popupName,
        "aria-expanded": this.state.isOpen,
        disabled: disabled,
        onClick: function onClick() {
          if (disabled) {
            return;
          }

          _this2.setState(function (prevState) {
            return {
              isOpen: openAlwaysOnTriggerClick ? true : !prevState.isOpen,
              isTriggerClicked: true
            };
          });
        }
      }, triggerContent), (0, _preact.h)(_GlobalClick.default, {
        Component: "ul",
        tabIndex: -1,
        role: popupName ? 'menu' : 'list',
        ref: function ref(dropdownContent) {
          _this2.dropdownContent = dropdownContent;
        },
        style: {
          maxHeight: "".concat(customHeight !== null && customHeight !== void 0 ? customHeight : 'auto')
        },
        className: (0, _classnames.default)(className, 'c-dropdown__content', "c-dropdown__content-size-".concat(size), "c-dropdown__content-position-".concat(position), "c-dropdown__content-align-".concat(align), {
          'is-hidden': !this.state.isOpen,
          'c-dropdown__content-overflow': this.state.overflow
        }),
        onChildrenClick: function onChildrenClick() {
          if (closeOnDropdownClick) {
            return _this2.setState({
              isOpen: false,
              isTriggerClicked: false
            });
          }

          return '';
        },
        onGlobalClick: function onGlobalClick() {
          _this2.state.isTriggerClicked ? _this2.setState({
            isTriggerClicked: false
          }) : _this2.setState({
            isOpen: false,
            isTriggerClicked: false
          });
        }
      }, (0, _typeGuards.isFunction)(renderPropChildren) ? renderPropChildren({
        close: function close() {
          return _this2.setState({
            isOpen: false,
            isTriggerClicked: false
          });
        }
      }) : null, children));
    }
  }]);
  return DropdownComponent;
}(_preact.Component);

exports.default = DropdownComponent;